import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { primaryBlue, textColorGray } from 'theme/mainColors';

class MaterialTextField extends React.PureComponent {
  state = {
    touched: false
  };

  handleTextFieldChange = (event, value) => {
    this.props.onChange(event, value);
  };

  handleOnBlur = ev => {
    this.setState({ touched: true });
    this.props.onBlur(ev);
  };

  render () {
    const {
      name,
      label,
      value,
      hintText,
      fullWidth,
      style,
      type,
      required,
      pristineForm,
      errorText,
      disabled
    } = this.props;
    return (
      <TextField
        fullWidth={ fullWidth }
        floatingLabelText={ label }
        value={ value }
        name={ name }
        onChange={ this.handleTextFieldChange }
        onBlur={ this.handleOnBlur }
        floatingLabelStyle={ {
          color: textColorGray,
          whiteSpace: 'nowrap',
          maxWidth: '100%',
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        } }
        underlineStyle={ { borderColor: textColorGray } }
        underlineFocusStyle={ { borderColor: primaryBlue } }
        inputStyle={ { fontSize: 15 } }
        type={ type }
        style={ style }
        errorText={ errorText || ((required && !value && this.state.touched && !pristineForm)? 'This field is required' : '') }
        hintText={ hintText }
        disabled={ disabled }
        underlineDisabledStyle={ {
          borderStyle: 'solid',
          borderWidth: 1
        } }
      />
    );
  }
}

MaterialTextField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  required: PropTypes.bool,
  pristineForm: PropTypes.bool,
  hintText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  onBlur: PropTypes.func,
  style: PropTypes.object,
  errorText: PropTypes.string,
  disabled: PropTypes.bool
};

MaterialTextField.defaultProps = {
  hintText: '',
  type: 'text',
  required: false,
  fullWidth: true,
  pristineForm: false,
  style: {},
  onBlur: () => null,
  errorText: '',
  disabled: false,
  value: ''
};

export default MaterialTextField;



// WEBPACK FOOTER //
// ./src/shared/components/connectedTextField/c/materialTextField/MaterialTextField.js